import React, { memo, forwardRef } from "react";
const SvgMultiplication = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 8l16 16M24 8L8 24"
      />
    </svg>
  );
});
SvgMultiplication.displayName = "SvgMultiplication";
const MemoForwardRef = memo(SvgMultiplication);
export default MemoForwardRef;
